export enum DocumentTemplateType {
  RESIDENT = 'RESIDENT',
  EMPLOYEE = 'EMPLOYEE',
}
